import React from "react";
import ReportWorkspace from "./ReportWorkspace";

const ReportPaymentGeneral = props => (
  <ReportWorkspace
    type="paymentGeneral"
    history={props.history}
    detailBasePath="/reportpembayaran-general/detail"
  />
);

export default ReportPaymentGeneral;
